<template>
  <div
    @click="onLocationClick"
    v-bind:class="{ selected: selected }"
    class="simulationGroupPoint"
  >
    <div class="pointName">{{ location.name }}</div>
    <div class="pointControl">
      <v-switch :disabled="readonly" v-model="isActive" />
      <div v-if="!readonly" class="pointDelete">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click="removeLocationPoint()"
              >delete_forever</v-icon
            >
          </template>
          地点を削除
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SimulationContentDeliverySidebarPoint',
  props: {
    location: {
      type: Object,
      default: null,
    },
    group: {
      type: Object,
      default: null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('simulation', ['selectedLocation']),
    selected() {
      return this.location.id === this.selectedLocation.id
    },
    isActive: {
      get() {
        return this.location.isActive()
      },
      set(value) {
        this.location.updateStatus(value)
      },
    },
  },
  methods: {
    ...mapActions('simulation', {
      selectLocation: 'SELECT_LOCATION',
    }),
    async removeLocationPoint() {
      const result = await this.$confirm(undefined, {
        body: `地点 ${this.location.name} を削除します。よろしいですか？`,
      })
      if (result) {
        this.group.removeLocationPoint(this.location.id)
      }
    },
    onLocationClick() {
      this.selectLocation(this.location)
    },
  },
}
</script>

<style scoped>
.simulationGroupPoint {
  display: flex;
  align-items: center;
  flex: 1;
  padding: 5px 5px 5px 15px;
}

.simulationGroupPoint.selected {
  background: #cde6ff;
}

.pointName {
  width: 100%;
  text-overflow: ellipsis;
  overflow-x: hidden;
  white-space: nowrap;
  margin-right: 5px;
  margin-left: 32px;
}

.pointControl {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 30px;
}

.pointDelete {
  width: 30px;
}

.pointDelete ::v-deep .v-icon {
  color: #f44336;
}

.pointDelete.isActive ::v-deep .v-icon {
  display: none;
}
</style>
